const regionDisplayOptions = [
  {
    value: 'state',
    label: 'State',
  },
  {
    value: 'msa',
    label: 'State & MSA',
  },
  {
    value: 'zip3',
    label: 'States & Zip3',
  },
]

export default regionDisplayOptions
